import { render, staticRenderFns } from "./history2.vue?vue&type=template&id=37f4388d&scoped=true&"
import script from "./history2.vue?vue&type=script&lang=js&"
export * from "./history2.vue?vue&type=script&lang=js&"
import style0 from "./history2.vue?vue&type=style&index=0&id=37f4388d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4388d",
  null
  
)

export default component.exports